import TransTopupBankType, { ITransTopupBankAction, TransTopupBankState } from "./transTopupBank.type";

const initialState: TransTopupBankState = {
    listBank: [],
    dataInitChangeBank: undefined,
    dataSaveChangeBank: undefined,
    isLoading: false,
    error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: ITransTopupBankAction) => {
    switch (action.type) {

        case TransTopupBankType.GET_BANK_LIST.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case TransTopupBankType.GET_BANK_LIST.SUCCESS:
            return {
                ...state,
                isLoading: false,
                listBank: action.payload,
            };
        case TransTopupBankType.GET_BANK_LIST.ERROR:
            return {
                ...state,
                isLoading: false,
                listBank: [],
                error: action.error,
            };

        case TransTopupBankType.INIT_CHANGE_BANK.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case TransTopupBankType.INIT_CHANGE_BANK.SUCCESS:
            return {
                ...state,
                isLoading: false,
                dataInitChangeBank: action.payload,
            };
        case TransTopupBankType.INIT_CHANGE_BANK.ERROR:
            return {
                ...state,
                isLoading: false,
                dataInitChangeBank: undefined,
                error: action.error,
            };

        case TransTopupBankType.SAVE_CHANGE_BANK.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case TransTopupBankType.SAVE_CHANGE_BANK.SUCCESS:
            return {
                ...state,
                isLoading: false,
                dataSaveChangeBank: action.payload,
            };
        case TransTopupBankType.SAVE_CHANGE_BANK.CLEAN:
            return {
                ...state,
                isLoading: false,
                dataInitChangeBank: undefined,
                dataSaveChangeBank: undefined
            };
        case TransTopupBankType.SAVE_CHANGE_BANK.ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };

        default:
            return state;
    }
};
